import { ITemplatesStore } from './index'

export default {
  grouped: {},
  request: {
    errMessage: '',
    isLoading: false,
  },
  templateSendModal: {
    event: null,
    isLoading: false,
    open: false,
  },
  templates: [],
} as ITemplatesStore
